import { css } from "@emotion/react"
import "./chakra-overrides.scss"

export const GlobalStyles = css``
